module.exports = __webpack_public_path__ + "static/img/partners3.e0e5eb3a.png";